import { render, staticRenderFns } from "./DialogAboutusContent.vue?vue&type=template&id=7b61f10e&scoped=true&"
var script = {}
import style0 from "./DialogAboutusContent.vue?vue&type=style&index=0&id=7b61f10e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b61f10e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
